import { useMemo } from 'react';

import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';

export function useIsInternalProject(projectOrgId: number | null) {
  const currentOrgId = useCurrentOrgId();

  return useMemo(() => {
    if (!projectOrgId || !currentOrgId) return false;
    return projectOrgId === currentOrgId;
  }, [projectOrgId, currentOrgId]);
}
